<template>
  <el-container  style="display: block;">
  <el-row :span="2" style="margin-top: 30px;">
      <el-button type="primary" style="background-color: #409eff;margin-left: 50px;" @click="addj()" round>添加矩阵</el-button>
  </el-row>

  <el-row   v-for="(itemj,keyj) in data"  class="elementsz" style="margin-top: 30px;margin-left: 30px;border: 1px solid #d5c8c8;">
    <el-row style="margin-top: 10px;text-align: center;">
      <h2 @click="changename(itemj[0][0]['name'])">{{itemj[0][0]['name']}}</h2>
    </el-row>
    <el-row v-for="(itemp,keyp) in itemj" style="margin-top: 10px;">
      <el-col v-for="(itemh,keyh) in itemp" @click.native="changeid(itemh['id'],itemh['AppId'])" :span='2'>{{itemh['AppId']}}({{itemh['num']}})<i class="el-icon-delete" @click="del(itemh['id'])" style="margin-left: 10px;"></i></el-col>
      <el-col :span='2'><el-button type="primary" style="background-color: #409eff;margin-left: 50px;" @click="addh(keyj,keyp,itemj[0][0]['name'])" round>添加行</el-button></el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-button type="primary" style="background-color: #409eff;" @click="addp(keyj,itemj[0][0]['name'])" round>添加排</el-button>
    </el-row>
  </el-row>

  <el-dialog
    title="修改AppId"
    :visible.sync="centerDialogVisible"
    width="30%"
    center>
    <input type="text" class="searchT" v-model="appid"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="centerDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doChangeid()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="修改矩阵名称"
    :visible.sync="nameDialogVisible"
    width="30%"
    center>
    <input type="text" class="searchT" v-model="name"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="nameDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doChangeName()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         data:[],
         appid:'',
         idc:0,
         centerDialogVisible:false,
         nameDialogVisible:false,
         name:'',
         nameid:''


      }
    },
	directives: {
    },
    created() {
      let that = this

      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();

    },


	methods:{

    addj(){
      const a = this.data.length+1
      this.add('矩阵'+a,1,1,'appid')
      // this.data.push([[{'AppId':'appid','num':'1-1','name':'矩阵'+a}]])
    },
    addp(j,name){

      const a = this.data[j].length+1
      this.add(name,a,1,'appid')
      // this.data[j].push([{'AppId':'appid','num':a+'-1','name':name}])
    },
    addh(j,p,name){
      const a = p+1
      const b = this.data[j][p].length+1

      this.add(name,a,b,'appid')
      // this.data[j][p].push({'AppId':'appid','num':a+'-'+b,'name':name})
    },
    add(name,p,h,appid){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          app:appid,
          name:name,
          p:p,
          h:h,
          scw:2

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/juzhenadd'
      })
      .then(res=>{
      	this.loadData()


      })
      .catch(err=>{

      });
    },
    changename(name){
      this.name = name
      this.nameid = name
      this.nameDialogVisible = true
    },
    doChangeName(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.nameid,
          name:this.name,
          t:2

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/juzhenchange'
      })
      .then(res=>{
        this.nameid = ''
        this.name = ''
        this.nameDialogVisible = false
      	this.loadData()


      })
      .catch(err=>{

      });
    },
    changeid(id,appid){
      this.idc = id
      this.appid = appid
      this.centerDialogVisible = true
    },
    doChangeid(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.idc,
          name:this.appid,
          t:1

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/juzhenchange'
      })
      .then(res=>{
        this.idc = 0
        this.appid = ''
        this.centerDialogVisible = false
      	this.loadData()


      })
      .catch(err=>{

      });
    },
    del(id){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/juzhendel'
      })
      .then(res=>{
        this.centerDialogVisible = false
      	this.loadData()


      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:2,
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/juzhenlist'
    	})
    	.then(res=>{
    		this.data = res.data.data;


    	})
    	.catch(err=>{

    	});
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
  .yuansushangxian{
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/yuzhoutiankong.vue